import { DEFAULT_CHAIN_ID } from 'config/chains'
import { useEthersSigner } from 'hooks/contracts/useEthersSigner'
import { useRouter } from 'next/router'
import { useAccount } from 'wagmi'

export default function useWallet() {
  const { address, isConnected, connector, chain } = useAccount()
  const signer = useEthersSigner()
  const { query } = useRouter()

  return {
    account: address as string,
    active: isConnected,
    connector,
    chainId: chain?.id || Number(query?.chainId) || DEFAULT_CHAIN_ID,
    signer: signer ?? undefined,
  }
}
